import React from "react";
import "./InfoBox.css";
import { Card, CardContent, Typography } from "@material-ui/core";
import { numWithComas } from "./util";

//...props means any other props: onClick is inside of here
function InfoBox({ title, cases, active, total, isRed, ...props }) {
  return (
    <Card
      onClick={props.onClick}
      className={`infoBox ${active && "infoBox--selected"} ${
        isRed && "infoBox--red"
      }`}
    >
      <CardContent>
        {/* title Coronovirus Cases*/}
        {/* Typography has its own stile */}
        <Typography className="infoBox__title" color="textSecondary">
          {title}
        </Typography>
        {/* Number of cases */}
        <h3
          className={`infoBox__cases ${!isRed && "infoBox__cases--green"} ${
            cases === 0 && "infoBox__cases--NA"
          }`}
        >
          {cases === 0 ? "Today's number not arrived yet" : numWithComas(cases)}
        </h3>
        <Typography className="infoBox__total" color="textSecondary">
          {numWithComas(total)} Total
        </Typography>
        {/* Total */}
      </CardContent>
    </Card>
  );
}

export default InfoBox;
